import { GoToAccountSettingsCTA } from "./ctas";
export var EoriDetailsIA = function EoriDetailsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return WHAT_IS_EORI(strictLocalize);
    },
    getDescription: function getDescription() {
      return [EORI_DEFINITION(strictLocalize), NODE_ON_ORDERS_WITHOUT_EORI(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return GoToAccountSettingsCTA(strictLocalize);
};
var WHAT_IS_EORI = function WHAT_IS_EORI(strictLocalize) {
  return strictLocalize({
    id: "JyA1NQ",
    defaultMessage: [{
      "type": 0,
      "value": "Qu'est-ce qu'un numéro EORI ?"
    }]
  });
};
var EORI_DEFINITION = function EORI_DEFINITION(strictLocalize) {
  return strictLocalize({
    id: "VfEzWr",
    defaultMessage: [{
      "type": 0,
      "value": "Le numéro « d'enregistrement et d'identification des opérateurs économiques » (EORI) est un numéro unique utilisé par les entreprises pour s'identifier auprès des autorités douanières sur les déclarations en douane et autres documents d'importation. Vous pouvez ajouter ou mettre à jour votre numéro EORI dans votre profil Faire, dans la section « Informations douanières et fiscales » de la page « Paramètres du compte »."
    }]
  });
};
var NODE_ON_ORDERS_WITHOUT_EORI = function NODE_ON_ORDERS_WITHOUT_EORI(strictLocalize) {
  return strictLocalize({
    id: "g5oER+",
    defaultMessage: [{
      "type": 0,
      "value": "Remarque : les commandes sans numéro EORI risquent d'être retenues en douane et peuvent être retournées à l'expéditeur. Si vous n'avez pas de numéro EORI, vous pouvez en demander un sur le site Web de votre administration locale. La demande est gratuite et ne prend que quelques minutes. Vous recevrez votre numéro EORI dans les 3 à 5 jours ouvrés."
    }]
  });
};